import { type Transition, useReducedMotion } from "framer-motion";

const instant: Transition = { duration: 0 };

/**
 * Returns the given transition, or an instant one when the user prefers
 * reduced motion. Called without an argument it yields framer's defaults.
 *
 * `MotionConfig reducedMotion="user"` only skips transform and layout
 * properties; everything else (opacity, width, height) keeps animating. Any
 * element that animates both kinds at once therefore half-moves: an overlay
 * settles on a different frame than its panel, and a sliding indicator jumps
 * to its new position while still resizing. Collapsing the whole transition to
 * zero keeps those properties in sync.
 */
export function useMotionTransition(transition?: Transition): Transition {
  return useReducedMotion() ? instant : (transition ?? {});
}
